export const ANKORPAY_HELP_LINK = 'https://ankorpay.productfruits.help/en/article/how-to-contact-support'
